import { Dialog, DialogContent, DialogProps, DialogTitle } from '@mui/material'
import { Asset } from '../types'
import AssetHistoryList from './AssetHistoryList'
import { useTranslation } from 'react-i18next'

export interface AssetHistoryDialogProps extends Omit<DialogProps, 'children'> {
  assetHistory: Record<string, Asset>
}

export default function AssetHistoryDialog({
  assetHistory,
  open,
  onClose
}: AssetHistoryDialogProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('assetHistory')}</DialogTitle>
      <DialogContent>
        <AssetHistoryList assetHistory={assetHistory} />
      </DialogContent>
    </Dialog>
  )
}
